import React from "react";
import Layout from "../layout/Layout";
import HomePage from "../templates/home-preview/Main";
import { useSeoData } from "../templates/seo/Main";

const IndexPage = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;
  return (
    <Layout crumbs={crumbs} crumbLabel={"Home"}>
      <HomePage />
    </Layout>
  );
};

export default IndexPage;

// Seo meta details
export const Head = () => {
  const { meta_title, meta_description, meta_keyword } = useSeoData("home");

  return (
    <>
      <title>{meta_title}</title>
      <meta
        name="description"
        content={meta_description?.data?.meta_description}
      />
      <meta name="keywords" content={meta_keyword?.data?.meta_keyword} />
      <meta name="robots" content="noindex, nofollow" />
    </>
  );
};
